<template>
    <div v-if="!currentUser && !error" class="has-text-centered mt-6">
        <base-spinner></base-spinner>
    </div>
    <div v-else-if="error && !currentUser" class="main">
        <div class="notification is-danger is-light"><p>{{ error }}</p></div>
    </div>
    <div v-else-if="currentUser" class="main">
        <h1 class="title is-4">My Profile</h1>
        <div v-if="!!error" class="notification is-danger is-light">
            <p>{{ error }}</p>
        </div>
        <div class="block">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Email</label>
                </div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="control">
                            <input v-model="currentUser.email" class="input" type="text" disabled>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Name</label>
                </div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="control">
                            <input v-model="currentUser.name" class="input" type="text">
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Phone number</label>
                </div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="field has-addons">
                            <p class="control">
                                <span class="select">
                                    <select v-model="phoneCountryCode">
                                        <option value="+65">🇸🇬 +65</option>
                                        <option value="+60">🇲🇾 +60</option>
                                        <option value="+91">🇮🇳 +91</option>
                                        <option value="+61">🇦🇺 +61</option>
                                        <option value="+44">🇬🇧 +44</option>
                                        <option value="+1">🇺🇸 +1</option>
                                    </select>
                                </span>
                            </p>
                            <p class="control is-expanded">
                                <input v-model="phoneLocal" class="input" type="tel" inputmode="numeric"
                                    placeholder="91234567">
                            </p>
                        </div>
                        <p class="help">Apex will use your phone number to contact you exclusively during the Food
                            Distribution in case of an unexpected event.</p>
                        <p class="help">Apex will never share your personal information to any other individual or
                            organization.</p>
                    </div>
                </div>
            </div>

            <div class="field">
                <div class="control align-center">
                    <button :disabled="!currentUser.name || !phoneLocal" class="button is-info is-rounded"
                        @click="updateProfile" :class="[isLoading ? 'is-loading' : '']">Update</button>
                </div>
            </div>
        </div>

        <div v-if="validationErrors.length" class="block notification is-danger is-light">
            <p>
                <b>Please correct the following error(s):</b>
            <ul>
                <li v-for="validationError in validationErrors" :key="validationError">{{ validationError }}</li>
            </ul>
            </p>
        </div>

        <div v-if="isSuccess" class="notification is-success">
            Profile updated successfully!
        </div>

            <router-link to="/">
                <svg width="40" height="40" viewBox="0 0 32 32">
                    <path fill="#3e8ed0"
                        d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2Zm8 15H11.85l5.58 5.573L16 24l-8-8l8-8l1.43 1.393L11.85 15H24Z" />
                    <path fill="none" d="m16 8l1.43 1.393L11.85 15H24v2H11.85l5.58 5.573L16 24l-8-8l8-8z" />
                </svg>
            </router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            edit: false,
            error: null,
            isFormValid: true,
            validationErrors: [],
            phoneCountryCode: '+65',
            phoneLocal: ''
        }
    },
    async mounted() {
        if (!this.currentUser) {
            try {
                await this.$store.dispatch('user/loadUserProfile');
            } catch (e) {
                this.error = 'Could not load your profile. Please try again.';
            }
        }
        this.parsePhone(this.currentUser && this.currentUser.phone);
    },
    watch: {
        currentUser(user) {
            if (user && !this.phoneLocal) {
                this.parsePhone(user.phone);
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/getCurrentUser'];
        },
        currentUserID() {
            return this.$store.getters['user/getCurrentUserID'];
        }

    },
    methods: {
        parsePhone(phone) {
            if (!phone) return;
            const phoneStr = String(phone);
            const known = ['+65', '+60', '+61', '+44', '+91', '+1'];
            const match = known.find(c => phoneStr.startsWith(c));
            if (match) {
                this.phoneCountryCode = match;
                this.phoneLocal = phoneStr.slice(match.length).trim();
            } else {
                this.phoneCountryCode = '+65';
                this.phoneLocal = phoneStr;
            }
        },
        async updateProfile() {
            this.isLoading = true;

            this.validateForm();

            if (this.isFormValid) {
                const fullPhone = this.phoneCountryCode + this.phoneLocal.trim();
                try {
                    if (this.currentUser.id == 'USER_NOT_FOUND') {
                        await this.$store.dispatch('user/createUser', {
                            name: this.currentUser.name,
                            email: this.currentUser.email,
                            phone: fullPhone
                        });
                    } else {
                        await this.$store.dispatch('user/updateUser', {
                            name: this.currentUser.name,
                            userID: this.currentUserID,
                            phone: fullPhone
                        });
                    }
                    this.isSuccess = true;
                } catch (error) {
                    this.error = error.message || 'Something went wrong!';
                }
            }

            this.isLoading = false;
        },
        validateForm() {
            this.isFormValid = false;
            this.validationErrors = [];
            this.currentUser.name = this.currentUser.name.trim();
            if (!this.currentUser.name) {
                this.validationErrors.push("Name is required.");
            } else {
                if (this.currentUser.name.length < 2) {
                    this.validationErrors.push("Name must have atleast 2 character");
                }
                var re = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
                if (!re.test(this.currentUser.name)) {
                    this.validationErrors.push("Name is not valid.");
                }
            }
            if (!this.phoneLocal.trim()) {
                this.validationErrors.push("Phone number is required.");
            } else {
                if (!/^[\d\s\-()]{6,15}$/.test(this.phoneLocal.trim())) {
                    this.validationErrors.push("Please enter a valid phone number.");
                }
            }
            if (!this.validationErrors.length) {
                this.isFormValid = true;
            }
        }
    }
}
</script>